import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { Box, Button, Card, Chip, Collapse, Container, FormControl, Grid, Grid2, IconButton, InputLabel, MenuItem, Pagination, Paper, Select, SelectChangeEvent, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { SetStateAction, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FilterSidebar from '../../components/filter/filter';
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';
import { ProductGridView } from '../../components/productCard/productGridView';
import { ProductListView } from '../../components/productCard/productListView';
import { SEARCH_PRODUCTS } from '../../redux/apis';
import './ProductList.css';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from "../../redux/reducers";
import { useNavigate } from "react-router-dom";
import { removeAllProductsToCompare, removeProductsToCompare } from '../../redux/actions';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Close } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';

const HEIGHT = window.innerHeight
const WIDTH = window.innerWidth
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export const useStyles = makeStyles({
    mainPart: {
        backgroundColor: 'transparent',
        minWidth: '1000px',
        overflowX: 'auto'
        // width: WIDTH * 90 / 100,
    },
    titleText: {
        color: '#000000',
        fontSize: 20,
        marginBottom: HEIGHT / 100 * 1,
    },
    container: {
        height: HEIGHT / 100 * 33,
        backgroundColor: '#fff',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headLine: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: '100%'
    },
    catBox: {
        height: HEIGHT / 100 * 11.5,
        width: HEIGHT / 100 * 11.5,
        borderColor: '#C4C4C4',
        borderWidth: 1,
        borderRadius: 8,
        alignItems: "center",
        paddingTop: 10,
        paddingBottom: 10,
        marginRight: WIDTH / 100 * 2
    },
    catBox1: {
        height: HEIGHT / 100 * 11.5,
        width: HEIGHT / 100 * 11.5,
        borderColor: '#C4C4C4',
        borderWidth: 1,
        borderRadius: 8,
        alignItems: "center",
        paddingTop: 10,
        paddingBottom: 10,
        marginRight: WIDTH / 100 * 5
    },
    catText: {
        color: "#030712",
        fontSize: 10,
        textAlign: "center",
        height: 40,
        textAlignVertical: 'center',
        lineHeight: 12
    },
    BestBox: {
        // height: HEIGHT / 100 * 25,
        // width: WIDTH < 400 ? (WIDTH * 45 / 100) : (WIDTH / 100 * 15),
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#C4C4C4',
        padding: WIDTH / 100 * 1,
        // marginRight: WIDTH / 100 * 2,
        flexDirection: "row",
        backgroundColor: 'white',
    },
    BestBoxs: {
        // width: WIDTH < 400 ? 'auto' : WIDTH / 100 * 60,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#C4C4C4',
        padding: WIDTH / 100 * 1,
        // marginRight: WIDTH / 100 * 2,
        flexDirection: "row",
        backgroundColor: 'white',
    },
    bestText: {
        color: '#2B2B2D',
        fontSize: 15,
        fontWeight: "600"
    },
    bestText1: {
        marginBottom: HEIGHT * 2 / 100,
        color: '#ADADAD',
        fontSize: 13,
        fontWeight: "600"
    },
    orgText: {
        color: '#c72a22',
        fontSize: 13,
        fontWeight: '600'
    },
    crsText: {
        color: '#7A7A7A',
        fontSize: 13,
        marginLeft: WIDTH / 100 * 0.5,
        marginRight: WIDTH / 100 * 1,
        textDecorationLine: 'line-through'
    },
    crsTextNormal: {
        color: '#7A7A7A',
        fontSize: 13,
        marginLeft: WIDTH / 100 * 0.5,
        marginRight: WIDTH / 100 * 1,
    },
    starCount: {
        fontSize: 11,
        color: '#999999'
    },
    buyBtn: {
        // height: HEIGHT / 100 * 4,
        width: '100%',
        backgroundColor: "#278BED",
        borderRadius: 5,
        alignItems: "center",
        justifyContent: "center",
        display: 'flex'
    },
    buyText: {
        fontSize: 13,
        textAlign: 'center',
        fontWeight: '600',
        color: '#FFFFFF'
    },
    offPart: {
        height: HEIGHT / 100 * 37,
        width: WIDTH / 100 * 15,
        // padding:WIDTH/100*3,
        marginRight: WIDTH / 100 * 2,
        justifyContent: "space-evenly"
    },
    dealTitle: {
        color: "#DC2626",
        fontSize: 28,
    },
    dealTitle1: {
        color: "#8B96A5",
        fontSize: 16,
    },
    dayText: {
        fontSize: 16,
        color: '#FFFFFF'
    },
    dayText1: {
        fontSize: 12,
        color: '#FFFFFF'
    },

    dayImgBack: {
        height: WIDTH / 100 * 2,
        width: WIDTH * 3.75 / 100,
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 15,
        paddingBottom: 15,
        marginRight: WIDTH / 100 * 0.5,
        marginTop: HEIGHT / 100 * 0.5,
        marginBottom: HEIGHT / 100 * 0.5,
        backgroundColor: 'red',
        display: 'flex'
    },
    // filterDisplay :
});

const ProductListPage = () => {
    const styles = useStyles();
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useNavigate();
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [products, setProducts] = useState<any>();
    const [sortBy, setSortBy] = React.useState<string>('priceAsc');
    const [selectedView, setSelectedView] = useState<any>("grid");
    const [urlParams, setUrlParams] = useState<string>("");
    const [searchCategoryId, setSearchCategoryId] = useState(null);
    const [searchText, setSearchText] = useState(null);
    const [expanded, setExpanded] = useState(false);
    // const selectedProductIds = useSelector((state: RootState) => state.productComparison.productIdsToCompare, (prev, next) => prev !== next);

    const selectedProductIds = useSelector((state: RootState) => state.productComparison.productIdsToCompare);

    useEffect(() => {
        if (location.state) {
            setSearchCategoryId(location.state.categoryId);
            setSearchText(location.state.searchText);
            fetchProductsWithPagination(1, location.state.categoryId, location.state.searchText, null);
        }
    }, [location.state, selectedProductIds]);

    const removeProductsCompare = () => {
        const productsIds = selectedProductIds.map(id => id.productId)
        dispatch(removeAllProductsToCompare(productsIds));
    }

    const handleSortChange = (event: SelectChangeEvent<string>) => {
        setPage(1);
        setSortBy(event.target.value as string);
        fetchProductsWithPagination(1, searchCategoryId, searchText, null, event.target.value);
    };

    const updateData = (urlParams: any) => {
        if (urlParams && urlParams != "") {
            setUrlParams(urlParams);
            fetchProductsWithPagination(1, searchCategoryId, searchText, urlParams);
        }
    }

    const fetchProductsWithPagination = async (page: number, categoryId: any, searchText: any, urlParams: any, sortBy?: any) => {
        let search_url = SEARCH_PRODUCTS + "?page=" + (page - 1) + "&pageSize=12";
        if (categoryId && categoryId != "") {
            search_url = search_url + "&categoryId=" + categoryId;
        }
        if (urlParams && urlParams != "") {
            search_url = search_url + urlParams;
        }

        if (searchText && searchText != "") {
            search_url = search_url + "&productName=" + searchText;
        }
        if (sortBy && sortBy != "") {
            let sortingOrder = "";
            if (sortBy === 'priceAsc') {
                sortingOrder = "ASC";
            } else if (sortBy === 'priceDesc') {
                sortingOrder = "DESC";
            }
            search_url = search_url + "&sortingOrder=" + sortingOrder;
        }

        const sampleProducts = [
            {
                "id":101,
                "productId": 101,
                "displayName": "2 MP Built-in Mic Fixed Bullet Network Camera",
                "shortDesc": "High quality surveillance camera with night vision and built-in microphone.",
                "longDesc":
                    "<p>This CCTV camera offers crystal clear video quality with advanced night vision technology. Suitable for homes, offices, and commercial use.</p><p>This CCTV camera offers crystal clear video quality with advanced night vision technology. Suitable for homes, offices, and commercial use.</p><p>It comes with a built-in microphone that captures audio clearly, ensuring complete surveillance coverage. The camera is designed to be weather-resistant, making it perfect for both indoor and outdoor use.</p><p> With easy installation and configuration via a mobile app, you can monitor your property from anywhere in real- time.The camera supports multiple mounting options and flexible viewing angles.</p>",
                "salePrice": 3200,
                "mrpPrice": 4000,
                "averageRating": 4.5,
                "totalRatings": 128,
                "saleWarranty": 12,
                "productWeight": 1.5,
                "taxPercent": 15,

                "category": {
                    "categoryId": 1,
                    "categoryName": "CCTV Camera"
                },

                "productDiscount": {
                    "discountType": "PERCENTAGE",
                    "discountValue": 20
                },

                "productImageUrl": require('../../../assets/Home/Cctv.png'),

                "productImages": [
                    {
                        "imageId": 1,
                        "imageUrl": require("../../../assets/first.png")
                    },
                    {
                        "imageId": 2,
                        "imageUrl": require("../../../assets/second.png")
                    },
                    {
                        "imageId": 3,
                        "imageUrl": require("../../../assets/third.png")
                    },
                    {
                        "imageId": 4,
                        "imageUrl": require("../../../assets/fourth.png")
                    }
                ],

                "productKeyFeatures": [
                    { "keyFeatureText": "2 MP Full HD Resolution" },
                    { "keyFeatureText": "Built-in Microphone" },
                    { "keyFeatureText": "Night Vision up to 30 meters" },
                    { "keyFeatureText": "Weather Resistant Body" }
                ],

                "productSpecifications": [
                    {
                        "specificationLabelName": "Resolution",
                        "specificationLabelText": "1920 × 1080"
                    },
                    {
                        "specificationLabelName": "Lens",
                        "specificationLabelText": "3.6mm Fixed Lens"
                    },
                    {
                        "specificationLabelName": "Power Supply",
                        "specificationLabelText": "12V DC"
                    },
                    {
                        "specificationLabelName": "Operating Temperature",
                        "specificationLabelText": "-10°C to 50°C"
                    }
                ],

                "installationInstruction": "<ul><li>Mount the camera securely</li><li>Connect power supply</li><li>Configure using mobile app</li></ul>",
                "productRelations": [
                    {
                        "productRelationId": 1,
                        "productId": 101,
                        "relatedProductId": 102,
                        "slimProduct": {
                            "productId": 102,
                            "productName": "16 GB SD Card",
                            "productImageUrl": require("../../../assets/came.png"),
                            "mrpPrice": 800,
                            "salePrice": 650,
                            "taxPercent": 5,
                            "productDiscount": { "discountType": "FIXED_AMOUNT", "discountValue": 50 },
                            "availableQuantity": 50
                        }
                    },
                    {
                        "productRelationId": 2,
                        "productId": 101,
                        "relatedProductId": 103,
                        "slimProduct": {
                            "productId": 103,
                            "productName": "Camera Mount Stand",
                            "productImageUrl": require("../../../assets/third.png"),
                            "mrpPrice": 1200,
                            "salePrice": 1000,
                            "taxPercent": 5,
                            "productDiscount": null,
                            "availableQuantity": 30
                        }
                    }
                ],

                "serviceProduct": {
                    "productId": 201,
                    "productName": "Professional Installation Service",
                    "productImageUrl": require("../../../assets/installation.png"),
                    "mrpPrice": 1500,
                    "salePrice": 1200,
                    "taxPercent": 5,
                    "productDiscount": { "discountType": "PERCENTAGE", "discountValue": 10 },
                    "availableQuantity": 10
                }

            },
            
            {
                "id":102,
                "productId": 102,
                "displayName": "2 MP Built-in Mic Fixed Bullet Network Camera",
                "shortDesc": "High quality surveillance camera with night vision and built-in microphone.",
                "longDesc":
                    "<p>This CCTV camera offers crystal clear video quality with advanced night vision technology. Suitable for homes, offices, and commercial use.</p><p>This CCTV camera offers crystal clear video quality with advanced night vision technology. Suitable for homes, offices, and commercial use.</p><p>It comes with a built-in microphone that captures audio clearly, ensuring complete surveillance coverage. The camera is designed to be weather-resistant, making it perfect for both indoor and outdoor use.</p><p> With easy installation and configuration via a mobile app, you can monitor your property from anywhere in real- time.The camera supports multiple mounting options and flexible viewing angles.</p>",
                "salePrice": 3200,
                "mrpPrice": 4000,
                "averageRating": 4.5,
                "totalRatings": 128,
                "saleWarranty": 12,
                "productWeight": 1.5,
                "taxPercent": 15,

                "category": {
                    "categoryId": 1,
                    "categoryName": "CCTV Camera"
                },

                "productDiscount": {
                    "discountType": "PERCENTAGE",
                    "discountValue": 20
                },

                "productImageUrl": require('../../../assets/Home/Cctv.png'),

                "productImages": [
                    {
                        "imageId": 1,
                        "imageUrl": require("../../../assets/first.png")
                    },
                    {
                        "imageId": 2,
                        "imageUrl": require("../../../assets/second.png")
                    },
                    {
                        "imageId": 3,
                        "imageUrl": require("../../../assets/third.png")
                    },
                    {
                        "imageId": 4,
                        "imageUrl": require("../../../assets/fourth.png")
                    }
                ],

                "productKeyFeatures": [
                    { "keyFeatureText": "2 MP Full HD Resolution" },
                    { "keyFeatureText": "Built-in Microphone" },
                    { "keyFeatureText": "Night Vision up to 30 meters" },
                    { "keyFeatureText": "Weather Resistant Body" }
                ],

                "productSpecifications": [
                    {
                        "specificationLabelName": "Resolution",
                        "specificationLabelText": "1920 × 1080"
                    },
                    {
                        "specificationLabelName": "Lens",
                        "specificationLabelText": "3.6mm Fixed Lens"
                    },
                    {
                        "specificationLabelName": "Power Supply",
                        "specificationLabelText": "12V DC"
                    },
                    {
                        "specificationLabelName": "Operating Temperature",
                        "specificationLabelText": "-10°C to 50°C"
                    }
                ],

                "installationInstruction": "<ul><li>Mount the camera securely</li><li>Connect power supply</li><li>Configure using mobile app</li></ul>",
                "productRelations": [
                    {
                        "productRelationId": 1,
                        "productId": 101,
                        "relatedProductId": 102,
                        "slimProduct": {
                            "productId": 102,
                            "productName": "16 GB SD Card",
                            "productImageUrl": require("../../../assets/came.png"),
                            "mrpPrice": 800,
                            "salePrice": 650,
                            "taxPercent": 5,
                            "productDiscount": { "discountType": "FIXED_AMOUNT", "discountValue": 50 },
                            "availableQuantity": 50
                        }
                    },
                    {
                        "productRelationId": 2,
                        "productId": 101,
                        "relatedProductId": 103,
                        "slimProduct": {
                            "productId": 103,
                            "productName": "Camera Mount Stand",
                            "productImageUrl": require("../../../assets/third.png"),
                            "mrpPrice": 1200,
                            "salePrice": 1000,
                            "taxPercent": 5,
                            "productDiscount": null,
                            "availableQuantity": 30
                        }
                    }
                ],

                "serviceProduct": {
                    "productId": 201,
                    "productName": "Professional Installation Service",
                    "productImageUrl": require("../../../assets/installation.png"),
                    "mrpPrice": 1500,
                    "salePrice": 1200,
                    "taxPercent": 5,
                    "productDiscount": { "discountType": "PERCENTAGE", "discountValue": 10 },
                    "availableQuantity": 10
                }

            },
            
        ]

        setProducts(sampleProducts);
        setTotalPages(1); // just for testing pagination
        // const response = await fetch(search_url)
        //     .then((response) => response.json())
        //     .then((data) => {
        //         if (data.pageableProducts) {
        //             setProducts(data.pageableProducts.content);
        //             setTotalPages(data.pageableProducts.totalPages);
        //         } else {
        //             setProducts(null);
        //             setTotalPages(0);
        //         }
        //     })
        //     .catch((error) => console.error(error));
    }

    const handlePageChange = (event: any, value: SetStateAction<number>) => {
        setPage(value);
        fetchProductsWithPagination(parseInt(value.toString()), searchCategoryId, searchText, null, sortBy);
    };

    const handleCompare = () => {
        history("/product-compare");
    }

    const handleRemoveCard = (product) => {
        // console.log(product.productId,'product')
        const productId = product.productId;
        dispatch(removeProductsToCompare(productId));
    }

    return (
        <>
            <Header />
            <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', minWidth: '1000px', marginTop: '105px' }}>
                <Box
                    flexDirection={'row'}
                    style={{ backgroundColor: '#fbfbfb' }}>
                    <>
                        <Box className={styles.mainPart}>
                            <Grid2 container spacing={3}>
                                {(WIDTH > 700) &&

                                    <Grid2 size={3}>
                                        <FilterSidebar updateData={updateData} />
                                    </Grid2>
                                }
                                <Grid2 size={{ xl: 9, lg: 9, md: 9, sm: 9, xs: 12 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: "#F7F7F8", marginBottom: HEIGHT * 0.5 / 100 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Button variant={selectedView == 'grid' ? "contained" : 'outlined'} color="error" sx={{ minWidth: '40px', padding: 0 }} onClick={() => {
                                                // history('/productlist'), { state: datas }
                                                setSelectedView("grid");
                                            }}>
                                                <ViewModuleIcon />
                                            </Button>
                                            <Button variant={selectedView == 'list' ? "contained" : 'outlined'} color="error" sx={{ minWidth: '40px', marginLeft: 1, padding: 0 }} onClick={() => {
                                                // history('/productlist1'), { state: datas }
                                                setSelectedView("list");
                                            }}>
                                                <ViewListIcon style={{ color: "#c72a22" }} />
                                            </Button>
                                            <Typography sx={{ marginLeft: 2 }}>We found {products ? products.length : "no"} items for you!</Typography>
                                        </Box>
                                        <FormControl variant="outlined" sx={{ minWidth: 150 }}>
                                            <InputLabel>Sort By</InputLabel>
                                            <Select value={sortBy} onChange={handleSortChange} label="Sort By">
                                                <MenuItem value="priceAsc">Price: Low to High</MenuItem>
                                                <MenuItem value="priceDesc">Price: High to Low</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Grid2 container spacing={2}>
                                        {selectedView == 'grid' ? products && products.map((product: any, index: React.Key | null | undefined) => (
                                            <Grid2 key={index} size={{ xl: 3, lg: 3, md: 4, sm: 6, xs: 6 }}>
                                                <ProductGridView showCompareBtn={true} product={product} />
                                            </Grid2>
                                        )) : products && products.map((product: any, index: React.Key | null | undefined) => (
                                            <Grid2 key={index} size={12}>
                                                <ProductListView product={product} />
                                            </Grid2>
                                        ))}
                                        {selectedProductIds.length > 0 && (
                                            <>
                                                <Collapse in={!expanded} timeout={'auto'}>
                                                    <Box sx={{ position: 'fixed', bottom: 100, left: 0, zIndex: 1000, display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                        <IconButton
                                                            onClick={() => setExpanded(!expanded)}
                                                            sx={{
                                                                backgroundColor: '#013b',
                                                                borderRadius: '50px 50px 1px 1px',
                                                                width: '100px',
                                                                height: '10px',
                                                                color: 'white',
                                                                '&:hover': {
                                                                    backgroundColor: '#013b',
                                                                }
                                                            }}>
                                                            {expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                                        </IconButton>
                                                    </Box>
                                                    <Box sx={{ position: 'fixed', width: '100%', minWidth: '1100px', overflowX: 'auto', bottom: 0, left: 0, zIndex: 1000 }}>
                                                        <Box sx={{ padding: 2, height: '100px', backgroundColor: '#013b', border: '1px solid #013b', borderRadius: 1, }}>
                                                            <Box sx={{ padding: '0 90px' }}>
                                                                <Box sx={{ justifyContent: 'space-between', alignItems: 'center', display: 'flex', }}>
                                                                    <Typography sx={{ color: '#fff', fontSize: '16px' }} variant="h6">Selected Products ({selectedProductIds.length})</Typography>

                                                                    <Grid2 container direction='row' spacing={2}>

                                                                        <Grid2>
                                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                                                {selectedProductIds.map((product, index) => (
                                                                                    <>
                                                                                        <Box key={index} sx={{ marginRight: 2, padding: '8px', height: '80px', width: '120px', display: "flex", position: 'relative', borderRadius: '8px' }}>
                                                                                            {/* <Button > */}
                                                                                            <Close onClick={() => handleRemoveCard(product)} sx={{ position: 'absolute', top: '-3px', right: '-2px', fill: 'white', zIndex: '1', cursor: 'pointer', bgcolor: 'red', borderRadius: '15px', fontSize: '1.25rem' }} />
                                                                                            {/* </Button> */}
                                                                                            <Card key={index} sx={{ padding: '2px', display: "flex", position: 'relative', borderRadius: '8px' }}>
                                                                                                <Box
                                                                                                    style={{ alignItems: "center", justifyContent: "center", marginTop: 2, marginBottom: 2, width: '100%' }}>
                                                                                                    <Box
                                                                                                        component="img"
                                                                                                        style={{ width: '120px', height: '80px' }}
                                                                                                        src={product.productImageUrl} />
                                                                                                </Box>
                                                                                            </Card>
                                                                                        </Box>
                                                                                    </>
                                                                                ))}
                                                                            </Box>
                                                                        </Grid2>
                                                                    </Grid2>
                                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                        <Button variant="outlined" sx={{ marginRight: 1, color: '#fff', borderColor: '#fff', height: '30px' }} onClick={() => {
                                                                            // Clear all selected products
                                                                            removeProductsCompare()
                                                                        }}>
                                                                            Clear All
                                                                        </Button>
                                                                        <Button variant="contained" sx={{ color: '#fff', backgroundColor: '#c72a22', height: '30px' }} onClick={() => {
                                                                            handleCompare()
                                                                        }}>
                                                                            Compare
                                                                        </Button>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Collapse>
                                                <Collapse in={expanded} timeout={'auto'}>
                                                    <Box sx={{ position: 'fixed', bottom: 180, left: 0, zIndex: 1000, display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                        <IconButton
                                                            onClick={() => setExpanded(!expanded)}
                                                            sx={{
                                                                backgroundColor: '#013b',
                                                                borderRadius: '50px 50px 1px 1px',
                                                                width: '100px',
                                                                height: '10px',
                                                                color: 'white',
                                                                '&:hover': {
                                                                    backgroundColor: '#013b',
                                                                }
                                                            }}>
                                                            {expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                                        </IconButton>
                                                    </Box>
                                                    <Box sx={{ position: 'fixed', width: '100%', minWidth: '1100px', overflowX: 'auto', bottom: 0, left: 0, zIndex: 1000 }}>
                                                        <Box sx={{ padding: 2, height: '180px', backgroundColor: '#013b', border: '1px solid #013b', borderRadius: 1, }}>
                                                            <Box sx={{ padding: '0 100px' }}>
                                                                <Box sx={{ justifyContent: 'space-between', alignItems: 'center', display: 'flex', }}>
                                                                    <Typography sx={{ color: '#fff', fontSize: '16px' }} variant="h6">Selected Products ({selectedProductIds.length})</Typography>

                                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                        <Button variant="outlined" sx={{ marginRight: 1, color: '#fff', borderColor: '#fff', height: '30px' }} onClick={() => {
                                                                            // Clear all 
                                                                            removeProductsCompare()
                                                                        }}>
                                                                            Clear All
                                                                        </Button>
                                                                        <Button variant="contained" sx={{ color: '#fff', backgroundColor: '#c72a22', height: '30px' }} onClick={() => {
                                                                            handleCompare()
                                                                        }}>
                                                                            Compare
                                                                        </Button>
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: '15px' }}>
                                                                    <Grid2 container direction='row' spacing={2}>
                                                                        <Grid2>
                                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                                                {selectedProductIds.map((product, index) => (
                                                                                    <>
                                                                                        <Box key={index} sx={{ marginRight: 2, padding: '8px', height: '100px', width: '200px', display: "flex", position: 'relative', borderRadius: '8px' }}>
                                                                                            {/* <Button > */}
                                                                                            <Close onClick={() => handleRemoveCard(product)} sx={{ position: 'absolute', top: '-3px', right: '-2px', fill: 'white', zIndex: '1', cursor: 'pointer', bgcolor: 'red', borderRadius: '15px', fontSize: '1.25rem' }} />
                                                                                            {/* </Button> */}
                                                                                            <Card key={index} sx={{ padding: '2px', display: "flex", position: 'relative', borderRadius: '8px' }}>

                                                                                                <Grid2 container spacing={1}>
                                                                                                    <Grid2 size={{ xs: 3.5, md: 4 }}>
                                                                                                        <Box
                                                                                                            style={{ alignItems: "center", justifyContent: "center", marginTop: 2, marginBottom: 2, width: '100%' }}>

                                                                                                            <Box
                                                                                                                component="img"
                                                                                                                style={{ width: '50px', height: '40px' }}
                                                                                                                src={product.productImageUrl} />
                                                                                                        </Box>
                                                                                                    </Grid2>
                                                                                                    <Grid2 size={{ xs: 8.5, md: 8 }}>
                                                                                                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                                                                                                            <Box sx={{
                                                                                                                maxWidth: { sx: 100, md: 200 },
                                                                                                                whiteSpace: 'normal',
                                                                                                                overflowWrap: 'break-word',
                                                                                                                wordBreak: 'break-word',
                                                                                                                padding: '2px',
                                                                                                            }}>
                                                                                                                <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>{product.productName ? product.productName : ""}</Typography>
                                                                                                            </Box>

                                                                                                            <Box sx={{ flexDirection: 'row', display: 'flex', mb: 1 }}>
                                                                                                                <Box style={{ flexDirection: "row" }}>
                                                                                                                    {product.salePrice ? <label className={styles.orgText}>${product.salePrice}</label> : <label className={styles.orgText}>$0</label>}
                                                                                                                </Box>
                                                                                                            </Box>
                                                                                                        </Box>
                                                                                                    </Grid2>
                                                                                                </Grid2>
                                                                                            </Card>
                                                                                        </Box>
                                                                                    </>
                                                                                ))}
                                                                            </Box>
                                                                        </Grid2>
                                                                    </Grid2>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Collapse>

                                            </>
                                        )}

                                    </Grid2>
                                </Grid2>
                            </Grid2>

                        </Box>
                    </>
                </Box>
                {products &&
                    <Box display="flex" justifyContent="center" mt={4} mb={3}>
                        <Pagination count={totalPages} page={page} showFirstButton showLastButton color="primary" onChange={handlePageChange}
                            className='justify-content-center' />
                    </Box>
                }
            </Container>
            <Footer />
        </>
    );
};

export default ProductListPage;